import { z } from 'zod';

// CPF (###.###.###-## ou apenas números)
export const cpfSchema = z
  .string()
  .max(11, 'O CPF deve ter no máximo 11 caracteres.')
  .transform(val => val.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4'))
  .refine(val => /^\d{3}\.\d{3}\.\d{3}-\d{2}$/.test(val), {
    message: 'CPF inválido',
  });

// CNPJ (##.###.###/####-## ou apenas números)
export const cnpjSchema = z
  .string()
  .transform((val) => val.replace(/\D/g, ''))
  .refine((val) => val.length === 14, {
    message: 'O CNPJ deve ter 14 dígitos',
  })
  .transform((val) =>
    val.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
  )
  .refine((val) => /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/.test(val), {
    message: 'CNPJ inválido',
  });


// E-mail (sem formatação, só valida)
export const emailSchema = z
  .string()
  .email('E-mail inválido');

// Telefone ((##) #####-#### ou (##) ####-####)
export const phoneSchema = z
  .string()
  .transform((val) => val.replace(/\D/g, ''))
  .refine((val) => val.length >= 10 && val.length <= 11, {
    message: 'Telefone deve ter 10 ou 11 dígitos',
  })
  .transform((digits) => {
    if (digits.length <= 10) {
      return digits.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3');
    }
    return digits.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3');
  })
  .refine((val) => /^\(?\d{2}\)?[\s-]?\d{4,5}-?\d{4}$/.test(val), {
    message: 'Telefone inválido',
  });

// CEP (#####-### ou ########)
export const cepSchema = z
  .string()
  .transform((val) => val.replace(/\D/g, ''))
  .refine((val) => val.length === 8, {
    message: 'O CEP deve ter 8 dígitos',
  })
  .transform((val) => val.replace(/(\d{5})(\d{3})/, '$1-$2'))
  .refine((val) => /^\d{5}-\d{3}$/.test(val), {
    message: 'CEP inválido',
  });

// URL
export const urlSchema = z
  .string()
  .url('URL inválida');

// Nome (mínimo 3 caracteres, sem formatação)
export const nomeSchema = z
  .string()
  .min(3, 'O nome deve ter pelo menos 3 caracteres.');

export const formatCnpj = (value) => {
  const digits = value.replace(/\D/g, '').slice(0, 14);
  return digits
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
};

export const formatCep = (value) => {
  const digits = value.replace(/\D/g, '').slice(0, 8);
  return digits.replace(/(\d{5})(\d)/, '$1-$2');
};

export const formatPhone = (value) => {
  const digits = value.replace(/\D/g, '').slice(0, 11);

  if (!digits) return '';

  if (digits.length <= 2) {
    return `(${digits}`;
  }
  if (digits.length <= 6) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  }
  if (digits.length <= 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
};

// Razão Social: mínimo 3 caracteres, obrigatório
export const razaoSocialSchema = z
  .string()
  .min(3, 'A razão social deve ter pelo menos 3 caracteres.');

// Nome Fantasia: mínimo 3 caracteres
export const nomeFantasiaSchema = z
  .string()
  .min(3, 'O nome fantasia deve ter pelo menos 3 caracteres.');

// Responsável: ao menos 1 selecionado
export const responsavelSchema = z
  .array(z.string())
  .min(1, 'Selecione ao menos um responsável.');

// Número: opcional, mas se tiver, precisa ser só dígito
export const numeroSchema = z
  .string()
  .optional()
  .refine(val => val === '' || /^\d+$/.test(val), {
    message: 'Número deve conter apenas dígitos.',
  });

// NIRE: opcional, mínimo 5 dígitos
export const nireSchema = z
  .string()
  .optional()
  .refine(val => val === '' || /^\d{5,}$/.test(val), {
    message: 'O NIRE deve conter pelo menos 5 dígitos.',
  });
